export const googleMapsConfig = {
  apiKey: 'AIzaSyBdC35-5lCVgehqsbH7xrMzlYKKZzdeGeg',
  mapId: 'CAQepcz2KgfU', // random map ip
};
